import React, { useEffect, useState, useRef } from 'react';
import Breadcrumb from "../../../components/common/breadcrumb";
import { URL_Start } from '../../../constant';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import axios from 'axios';
import SweetAlert from 'sweetalert2';
import { CSVLink } from "react-csv";
import InputGroup from 'react-bootstrap/InputGroup';
import { MultiSelect } from 'react-multi-select-component';
import LoadingButton from '../commonComponent/LoadingButton';
import Select from 'react-select';

const ConsumablesReport = () => {

    const [defaultDate, setDefaultDate] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [csvdata, setCSVData] = useState([]);
    const [downloadvisible, setDownloadVisible] = useState(false);
    const [centresdropdown, setCentresDropDown] = useState([]);
    const [selectcentre, setSelectCentre] = useState([]);
    const [selectedoptions, setSelectedOptions] = useState([]);
    const [CentreType, setCentreType] = useState([]);
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [typeSelected, setTypeSelected] = useState([]);
    const [itemname, setItemName] = useState([]);

    let fromDate = useRef();
    let toDate = useRef();
    let centretype = useRef();

    useEffect(() => {
        const today = new Date();
        const date = today.setDate(today.getDate());
        const defaultValue = new Date(date).toISOString().split('T')[0] // yyyy-mm-dd
        setDefaultDate(defaultValue);
        GetCentreType();
    }, [])

    const GetCentreType = async () => {
        try {
            let url = URL_Start + 'master/getpartnertypelist/2/1'
            await axios.get(url).then((response) => {
                const data = response.data;
                var arr = data.Data.filter((d) => d.Id != "7");
                arr = arr.filter((d) => d.Id != "10");
                if (data.Success) { setCentreType(arr.map((d) => (<option key={d.Id} value={d.Id}>{d.Name}</option>))); }
                else { setCentreType([]); }
            }).catch(function (error) { });
        }
        catch (error) { SweetAlert.fire({ title: "Server Inaccessible!", text: "You may not be connected to a network or Unable to connect to a server", icon: "error" }); }
    }
    const GetAllCentres = async (e) => {
        var glblArr = [];
        //setSelectCentre([]);
        setTypeSelected([]);
        if (e.target.value == "0") { setCentresDropDown([]); return false; }
        setIsLoading(true);
        let url = URL_Start + 'reports/getallcentres/' + e.target.value + '/' + localStorage.LoggedInUser
        await axios.get(url).then((response) => {
            const data = response.data;
            if (data.Success) {
                // let ds = data.Data;
                // const TypeOptionDs1 = [];
                // ds.map((option) => {
                //     const TypeOptions1 = {
                //         'value': option.Id,
                //         'label': option.Name,
                //         'disabled': false
                //     }
                //     return TypeOptionDs1.push(TypeOptions1);
                // });
                // setCentresDropDown(TypeOptionDs1);            
                if (data.Data != null) {
                    var itmData = data.Data;
                    itmData.map((option) => { return glblArr.push({ 'value': option.Id, 'label': option.Name, 'disabled': false }); });
                    setItemName(glblArr);
                }
                else { setItemName([]); }
                setIsLoading(false);
            }
            else { setCentresDropDown([]); setIsLoading(false); }
        }).catch(function (error) { if (error.response) { ErrorFunction(error.response.status); } setIsLoading(false); setCentresDropDown([]); });
    }
    // const CentreHandler = (options) => {
    //     setSelectCentre(options);
    //     const TypeOptL = [];
    //     if (options != null && options.length > 0) {
    //         options.map((item) => {
    //             const TypeOptrows = {
    //                 'CentreId': item.value
    //             }
    //             return TypeOptL.push(TypeOptrows);
    //         });
    //         setSelectedOptions(TypeOptL);
    //     }
    //     else {
    //         setSelectedOptions([]);
    //     }
    // }
    const TypeChangeHandler = (options) => {
        var typearr = [];
        typearr.push({
            value: options.value,
            label: options.label
        })
        setTypeSelected(typearr);
    }
    const handleSearchList = async () => {
        setIsButtonLoading(true);
        var frmdte = "";
        var todte = "";
        if (fromDate.current.value === "" || fromDate.current.value === null || fromDate.current.value === undefined) { frmdte = "0"; } else { frmdte = fromDate.current.value }
        if (toDate.current.value === "" || toDate.current.value === null || toDate.current.value === undefined) { todte = "0"; } else { todte = toDate.current.value }
        if (frmdte == "0" && todte == "0") { setIsButtonLoading(false); SweetAlert.fire("From date and to date is mandatory"); return false; }
        if (frmdte == "0" && todte != "0") { setIsButtonLoading(false); SweetAlert.fire("From date is mandatory"); return false; }
        if (frmdte != "0" && todte == "0") { setIsButtonLoading(false); SweetAlert.fire("To date is mandatory"); return false; }
        // if (selectedoptions.length == 0 || selectedoptions == null || selectedoptions == undefined || selectedoptions == []) { setIsButtonLoading(false); SweetAlert.fire("Centre is mandatory to select"); return false; }
        if (typeSelected.length == 0 || typeSelected == null || typeSelected == undefined || typeSelected == []) { setIsButtonLoading(false); SweetAlert.fire("Centre is mandatory to select"); return false; }
        const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        const firstDate = new Date(toDate.current.value);
        const secondDate = new Date(fromDate.current.value);
        const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
        if (diffDays > 120) { setIsButtonLoading(false); SweetAlert.fire("You can select max 120 days difference between from date and to date"); return false; }
        else { GetPanelCentreReportData(); }

    }
    const GetPanelCentreReportData = async () => {
        setDownloadVisible(false);
        var arrfinal = [];
        arrfinal.push({
            CentreId: typeSelected[0].value
        })
        const requestoptions = {
            LoginId: localStorage.getItem('LoggedInUser'),
            FromDate: fromDate.current.value,
            ToDate: toDate.current.value,
            // CentreIdList: JSON.stringify(selectedoptions)
            CentreIdList: JSON.stringify(arrfinal)
        };
        try {
            let url = URL_Start + 'reports/getcorporatecentrereport'
            await axios.post(url, requestoptions).then((response) => {
                const data = response.data;
                setIsButtonLoading(false);
                if (data.Success) {
                    if (data.Data != null) { setDownloadVisible(true); setCSVData(data.Data); document.getElementById("csvdownload").click(); }
                    else {
                        setCSVData([]);
                        SweetAlert.fire("No record available");
                    }
                }
                else {
                    setCSVData([]);
                    if (data.Data == "-1") { SweetAlert.fire("Some db error occured.Please report to support team."); }
                    else { SweetAlert.fire("No record available"); }
                }
            }).catch(function (error) { if (error.response) { setIsButtonLoading(false); setCSVData([]); ErrorFunction(error.response.status); } });
        }
        catch (error) { SweetAlert.fire({ title: "Server Inaccessible!", text: "You may not be connected to a network or Unable to connect to a server", icon: "error" }); }
    }
    const ErrorFunction = async (ErrorCode) => {
        if (ErrorCode == "400") { SweetAlert.fire({ title: "Error 400", text: "Bad request", icon: "error" }); }
        else if (ErrorCode == "401") { SweetAlert.fire({ title: "Error 401", text: "Unauthorized", icon: "error" }); }
        else if (ErrorCode == "403") { SweetAlert.fire({ title: "Error 403", text: "Forbidden", icon: "error" }); }
        else if (ErrorCode == "404") { SweetAlert.fire({ title: "Error 404", text: "Page not found", icon: "error" }); }
        else if (ErrorCode == "500") { SweetAlert.fire({ title: "Error 500", text: "Internal Server Error", icon: "error" }); }
        else if (ErrorCode == "503") { SweetAlert.fire({ title: "Error 503", text: "Service Unavailable", icon: "error" }); }
    }
    return (
        <React.Fragment>
            <Breadcrumb title="Consumables Report" parent="Reports" />
            <Container fluid>
                <Row className='mt25'>
                    <Col md={12}>
                        <Card>
                            <Card.Body>
                                <Form.Row>
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>From Date <span className='text-red'>*</span></Form.Label>
                                            <InputGroup className="mb-3 d-flex justify-content-start">
                                                <Form.Control type="date" id="fromDate" name="fromDate" ref={fromDate} max={defaultDate} defaultValue={defaultDate} />
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>To Date <span className='text-red'>*</span></Form.Label>
                                            <InputGroup className="mb-3 d-flex justify-content-start">
                                                <Form.Control type="date" id="toDate" name="toDate" ref={toDate} max={defaultDate} defaultValue={defaultDate} />
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>Centre Type <span className='text-red'>*</span></Form.Label>
                                            <Form.Control as="select" name="centertype" onChange={(e) => GetAllCentres(e)}>
                                                <option key="0" value="0">---Select---</option>
                                                {CentreType}
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>Centres <span className='text-red'>*</span></Form.Label>
                                            {/* <div className='txtMultiSelect1'>
                                                <MultiSelect id="CentreSelect" name="CentreSelect"
                                                    options={centresdropdown}
                                                    value={selectcentre}
                                                    onChange={CentreHandler}
                                                    labelledBy="Select"
                                                /></div> */}
                                            <Select onChange={TypeChangeHandler}
                                                options={itemname}
                                                value={typeSelected} />
                                        </Form.Group>
                                    </Col>
                                </Form.Row>
                                <Form.Row>
                                    <Col md={12} className='text-center __center__buttonsec mb-4 mt25'>
                                        {isButtonLoading ? <LoadingButton variantName='primary' cssName="" /> :
                                            <Button variant='primary' onClick={handleSearchList} target="_blank" >Download CSV</Button>
                                        }
                                    </Col>
                                </Form.Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                {
                    downloadvisible &&
                    <CSVLink data={csvdata} filename="ConsumablesReport.csv" target="_blank" id="csvdownload"></CSVLink>
                }
            </Container>
        </React.Fragment>
    )
}

export default ConsumablesReport